import BaseObject from './BaseObject';
import {Matrix4, Mesh} from 'three';
import {CbctJawObjectDescription, JawType, MaterialTypes, ObjectTypes} from '@data/models';
import {GeometryProvider, MaterialsProvider} from '@data/providers';
import {WebGLScene} from '../WebGLScene';


class CbctJawObject extends BaseObject {
  constructor(mesh: Mesh) {
    super(mesh, ObjectTypes.CbctJaw);
  }

  static async create(
    description: CbctJawObjectDescription,
    scene: WebGLScene,
    geometryProvider: GeometryProvider,
    materialsProvider: MaterialsProvider
  ) {
    const mesh = new Mesh(
      geometryProvider.getGeometryByDescription(description),
      materialsProvider.getMaterial(description.jaw === JawType.Upper ? MaterialTypes.CbctUpperJaw : MaterialTypes.CbctLowerJaw),
    );

    const position = mesh.position.clone();
    const rotation = mesh.rotation.clone();
    const scale = mesh.scale.clone();

    if (description.transform) {
      const matrix = new Matrix4();
      matrix.fromArray(description.transform);
      matrix.transpose();
      mesh.applyMatrix4(matrix);
    }

    const obj = new CbctJawObject(mesh);
    obj.setInitial(position, rotation, scale);
    scene.getRootObject().add(obj.mesh);

    obj.id = description.id;
    obj.visible = description.visible;

    return obj;
  }
}

export default CbctJawObject;
